
import { filter } from 'rxjs/operators';
import { Component, Input, OnDestroy } from '@angular/core';
import { ClickOutsideService } from '../../../../Common/PageBuilder/services/click-outside.service';
import { Subscription } from 'rxjs';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { WireBlockTypeEnum } from '../../enums/wire-block-type.enum';
import { WireModel } from '../../models/wire.model';
import { WirePageBuilderService } from '../../services/wire-page-builder.service';
import { WireService } from '../../services/wire.service';


@Component({
    selector: 'agpr-wire-fake-block',
    templateUrl: './wire.fake.block.component.html',
    styleUrls: ['./wire.fake.block.component.scss'],
    standalone: false
})
export class WireFakeBlockComponent implements OnDestroy {

    @Input() id: string;
    @Input() editable: boolean = false;
    @Input() set wireBlockType(wireBlockType: WireBlockTypeEnum) {
        this._wireBlockType = wireBlockType;
        this.twigTemplate = this.wirePageBuilderService.getFakeBlockTwigTemplate(this._wireBlockType);

        this.updateTwigData();
    };
    @Input() icon: string;
    @Input() placeholder: string;
    @Input() height: number = 120;
    @Input() errorsId: string;


    readonly buttonTypes = ButtonTypesEnum;
    readonly blockTypes = WireBlockTypeEnum;
    readonly inlineAdderRegex: RegExp = /(agpr-inlineAdder-topButton)|(agpr-inlineAdder-panel)|(agpr-block)/;
    readonly fakeBlockAdderId: string = 'fakeBlockAdder';

    private subscriptions: Subscription[] = [];
    _wireBlockType: WireBlockTypeEnum;

    wire: WireModel;
    editing: boolean;
    renderable: boolean;
    twigTemplate: string;
    twigData: any = {};
    inlineAdderVisible: boolean = false;

    constructor(
        public wireService: WireService,
        public wirePageBuilderService: WirePageBuilderService,
        public clickOutsideService: ClickOutsideService
    ) {
        this.subscriptions.push(
            this.wireService.currentResource$.pipe(filter(x => !!x)).subscribe(wire => {
                this.wire = wire;
                this.twigTemplate = this.wirePageBuilderService.getFakeBlockTwigTemplate(this._wireBlockType);
                this.updateTwigData();
            }),
            this.wirePageBuilderService.getSelectedBlock().subscribe(block => {
                this.editing = !!block && (block.type.key === this._wireBlockType);
            }),
            this.wirePageBuilderService.getFakeBlockDataChange().subscribe(type => {
                if (type === this._wireBlockType) {
                    this.updateTwigData();
                }
            }),
            this.clickOutsideService.getClickOutsideBlock().pipe(filter(x => !!x)).subscribe(outside => {
                this.inlineAdderVisible = false;
                this.clickOutsideService.removeClassComparisonRegex();
            })
        );
    }

    emitClick() {
        if (this.editable) {
            this.wirePageBuilderService.selectFakeBlock(this._wireBlockType);
        }
    }

    deleteBlock(): void {
        this.wirePageBuilderService.deleteFakeBlock(this._wireBlockType);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(
            subscription => subscription.unsubscribe()
        );
    }

    updateTwigData() {
        if (!this.wire || !this._wireBlockType) {
            return;
        }

        this.twigData = this.wirePageBuilderService.getFakeBlockTwigData(this._wireBlockType);
        this.renderable = this.wirePageBuilderService.isFakeBlockRenderable(this._wireBlockType);
    }

    inlineAddToggle(){
        this.inlineAdderVisible = !this.inlineAdderVisible;
        if (this.inlineAdderVisible) {
            this.clickOutsideService.setClassComparisonRegex(this.inlineAdderRegex);
        } else {
            this.clickOutsideService.removeClassComparisonRegex();
        }
    }

    leaveBlockAdder(event: any): void {
        if (!(event?.relatedTarget as HTMLElement).id?.startsWith(this.fakeBlockAdderId)) {
            this.inlineAdderVisible = false;
        }
    }
}
